export const Colors = {
  white: "#fafafa",
  black: "#101010",
  lightBlack: "#1d2024",
  gray: "#ebebeb",
  blue: "#2D56A5",
  darkBlue: "#1f4387",
  green: "#22AA3E",
  darkGreen: "#168a2d",
};
